import TicketHttp from "../../ticketHttp";

class RefundServices{
  // Calling the phonepe after entering the data (existing usage)
  static async phonePePayment(data){
      return TicketHttp.post('/payment/pay', data);
  }

  // Send refund OTP for a booking
  static async sendRefundOtp(bookingId){
      return TicketHttp.post(`/refundotp/sendOtp/${bookingId}`);
  }

  // Verify refund OTP for a booking
  static async verifyRefundOtp(bookingId, otp){

    console.log('in the verifyRefunOtp', bookingId)
      return TicketHttp.post(`/refundotp/verify/${bookingId}`, { otp });
  }

}
export default RefundServices
